function normalizeId(value) {
    if (value && typeof value === "object") {
        return value.id;
    }

    return value;
}

export function buildSalesPlanFormModel(model = {}, processing = null) {
    const period = Array.isArray(model.period)
        ? model.period.filter((value) => value !== undefined && value !== null)
        : [model.period_start, model.period_end].filter((value) => value !== undefined && value !== null);

    return {
        product_id: normalizeId(model.product_id ?? model.product),
        partner_id: normalizeId(model.partner_id ?? model.partner),
        farm_id: normalizeId(model.farm_id ?? model.farm),
        processing_id: normalizeId(model.processing_id ?? model.processing),
        period,
        term_of_payment: model.term_of_payment,
        estimated_size_start: model.estimated_size_start,
        estimated_size_end: model.estimated_size_end,
        estimated_quantity: model.estimated_quantity,
        estimated_sale: model.estimated_sale,
        estimated_margin: model.estimated_margin,
        processing: processing ?? model.processing ?? {},
    };
}

export function buildSalesPlanPayload(model = {}, {saveAsDraft = false} = {}) {
    return {
        _action: saveAsDraft ? "draft" : "publish",
        product_id: normalizeId(model.product_id),
        partner_id: normalizeId(model.partner_id),
        farm_id: normalizeId(model.farm_id),
        processing_id: normalizeId(model.processing_id),
        period_start: model.period[0],
        period_end: model.period[1],
        term_of_payment: model.term_of_payment,
        estimated_size_start: model.estimated_size_start,
        estimated_size_end: model.estimated_size_end,
        estimated_quantity: model.estimated_quantity,
        estimated_sale: model.estimated_sale,
        estimated_margin: model.estimated_margin,
    };
}
